export const HENRIQUE_E_JULIANO = "HENRIQUE_E_JULIANO";

export const KAMILLA_FIALHO = "KAMILLA_FIALHO";

export const ANNO_DOMINI = "ANNO_DOMINI";
